import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.pageHeader';

export default defineMessages({
  instructors: {
    id: `${scope}.instructors`,
    defaultMessage: 'Instructors',
  },
});
